import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18.014" width="1em" height="1em" {...props}>
    <path d="M2.4 11.762l3.187-3.186 2.767 2.766L18 1.696V0L8.354 9.645 5.587 6.878 2.4 10.066z" />
    <path d="M16.8 4.615v12.199h-4.6V9.215l-1.2 1.2v6.399H7v-5.107l-1.2-1.2v6.307H1.2V.014H0v18h18V3.415z" />
  </svg>
);

export default SvgComponent;
